import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Dropdown } from "react-bootstrap";
import Loader from "rsuite/Loader";
import { DownloadBlueIcon } from "../../../components/Icons/icons.component";
import {
  COOKIE,
  DOWNLOAD_FORMATS,
  DOWNLOAD_FORMATS_FOR_DETAILS_PAGE,
  VERTICALS,
  DOWNLOAD_FORMATS_FOR_TV,
} from "../../../constants/app-constant";
import { fileDownloadMethod } from "../../../utility/requestHelper";
import { envConfig } from "../../../constants/api-endpoint";
import { getCookie, setCookie } from "../../../utility/cookieProvider";
import { groupBy, isLoggedIn } from "../../../utility/common-methods";
import ReactGA from "react-ga4";
import {GACODE} from "../../../constants/app-constant";
const { V_PRINT, V_ONLINE, V_PRINT_AND_ONLINE_OLD } = VERTICALS;

const DownloadFeeds = ({
  category,
  client_id,
  clientName,
  edition_id,
  end_date,
  start_date,
  entities,
  headline,
  keywords,
  press_release,
  publication_id,
  publication_type,
  publication_type_id,
  source_type,
  reporter,
  tonality,
  zone,
  media_type,
  article,
  articleInfoExtra,
  hideText,
  customParams,
  hideFormats,
  isInlineDownload,
  onSuccessCallback,
  print_article_ids,
  online_article_ids,
  singleNews = false,
  isTV,
  setIsLoading,
  isLoading,
}) => {
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID) || null;
  const concept_email = getCookie(COOKIE.CONCEPT_USER_EMAIL) || null;
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const getVerticalBasedArticleIds = (downloadAllEditions = false) => {
    try {
      let topEditions = groupBy(article, "headline", true);
      topEditions = Object.keys(topEditions).map((aId) => topEditions[aId][0]);
      const correctList = downloadAllEditions ? article : topEditions || [];
      const printArticleIds = correctList
        .filter((a) => a.article_type === "Print")
        .map((e) => e.article_id);
      const onlineArticleIds = correctList
        .filter((a) => a.article_type === "Online")
        .map((e) => e.article_id);
      if (media_type == V_PRINT) {
        return { onlineArticleIds: [], printArticleIds };
      }
      if (media_type == V_ONLINE) {
        return { onlineArticleIds, printArticleIds: [] };
      }
      if (media_type == V_PRINT_AND_ONLINE_OLD) {
        return { onlineArticleIds, printArticleIds };
      }
    } catch (e) {
      return { onlineArticleIds: [], printArticleIds: [] };
    }
  };

  const getSelectedFeedsEntity = () => {
    try {
      if (article && article.length && !isInlineDownload) {
        let uniqueEntities = groupBy(article, "entity_id");
        uniqueEntities = Object.keys(uniqueEntities);
        return uniqueEntities;
      }
      return entities;
    } catch (e) {
      console.info("Falling back to filters entity");
      return entities;
    }
  };

  const dropdownClick = (e, { format, type, label }) => {
    // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
    // console.log("format:",format);
    // console.log("type:",type);
    // console.log("label:",label);

    ReactGA.initialize(GACODE);    
    const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
    if(client_id != undefined && client_id != '' && client_id != null){ 
      ReactGA.set({ userId: client_id+".0."+concept_uid });
      ReactGA.set({ 'user_id': client_id+".0."+concept_uid });
    }
    
    let locationHrefNew = window.location.href;    
    if(client_id != undefined && client_id != '' && client_id != null){
      ReactGA.event({
        category: "Download",
        action: "PO DWND "+media_type+"_"+start_date+"_"+end_date,
        label: locationHrefNew, // optional
        //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
      });
    }

    e.preventDefault();
    const downloadAllEditions = label.indexOf("All") !== -1;
    const { printArticleIds, onlineArticleIds } =
      getVerticalBasedArticleIds(downloadAllEditions);
    if (format) {
      let tempParams = {
        client_id,
        media_type,
        start_date,
        end_date,
        user_id: concept_uid,
        download: format,
        email: concept_email,
        pdf_testing: 1,
      };
      if (!isInlineDownload) {
        if (printArticleIds && printArticleIds.length) {
          tempParams.print_article_ids = printArticleIds;
        }
        if (onlineArticleIds && onlineArticleIds.length) {
          tempParams.online_article_ids = onlineArticleIds;
        }
      }
      if (edition_id) {
        tempParams.edition_id = Array.isArray(edition_id)?edition_id:[edition_id];
      }
      if (publication_type && publication_type.length) {
        tempParams.publication_type = singleNews
          ? [`${publication_type_id}`]
          : publication_type.map((x) => `${x}`);
      }
      if (press_release && press_release.length) {
        tempParams.press_release = press_release;
      }
      if (entities && entities.length) {
        tempParams.entities = getSelectedFeedsEntity();
      }
      if (tonality && tonality.length) {
        tempParams.tonality = tonality;
      }
      if (publication_id && publication_id.length) {
        tempParams.publication_id = [`${publication_id}`];
      }
      if (source_type && source_type.length) {
        tempParams.source_type =
          source_type === "Online_Journalist" ? "Online_Jou" : source_type;
      }
      if (reporter && reporter.length) {
        tempParams.reporter = reporter;
      }
      if (print_article_ids && print_article_ids.length) {
        tempParams.print_article_ids = print_article_ids;
      }
      if (online_article_ids && online_article_ids.length) {
        tempParams.online_article_ids = online_article_ids;
      }
      if (keywords) {
        tempParams.keywords = keywords;
      }
      if (zone && zone.length) {
        tempParams.zone = [+zone];
      }
      if (category && category.length) {
        tempParams.category = category;
      }

      setIsLoading(true);
      // const getDownloadFeeds = () => {
      //   if (isLoggedIn()) {
      //     return envConfig.DOWNLOAD_ARTICLE;
      //   } else return envConfig.DOWNLOAD_ARTICLE + "/1";
      // };
      setCookie({
        key: COOKIE.IS_PRINT_DOWNLOADING,
        value: true,
      });
      fileDownloadMethod(
        `${
          !singleNews
            ? envConfig.DOWNLOAD_ARTICLE
            : envConfig.DOWNLOAD_ARTICLE_FOR_ONE
        } `,
        tempParams,
        !isLoggedIn()
          ? {
              Authorization:
                "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyIjoiNCRhbWl0LmNsaWVudEBjb25jZXB0Yml1LmNvbSJ9.VeM2QtccR6VhDsa8vC1XHQjU0GQA-wmdJRPaA2_cXmk",
              "Content-Type": "application/json",
            }
          : null,
        {
          type,
          clientName: selectedClient.client_name || clientName,
          articleInfoExtra,
        }
      )
        .then(() => {
          setCookie({
            key: COOKIE.IS_PRINT_DOWNLOADING,
            value: null,
          });
          setCookie({
            key: COOKIE.DOWNLOAD_SUCCESS,
            value: true,
          });
          setIsLoading(false);
          onSuccessCallback();
        })
        .catch(() => {
          setIsLoading(false);
          setCookie({
            key: COOKIE.IS_PRINT_DOWNLOADING,
            value: null,
          });
        });
    }
  };

  const dropdownClickForTv = (e) => {
    const {
      language_id,
      channel_id,
      anchor_id,
      is_client_favourite,
      headline,
      electronic_client_detail_id,
    } = article;
    e.preventDefault();
    // const downloadAllEditions = label.indexOf("All") !== -1;
    if (article && article.length) {
      let tempParams = {
        client_id,
        media_type,
        start_date,
        end_date,
        user_id: concept_uid,
        download: "excel",
        email: concept_email,
        pdf_testing: 1,
        electronic_client_detail_ids: article.map(
          ({ electronic_client_detail_id }) => electronic_client_detail_id
        ),
      };
      if (entities && entities.length) {
        tempParams.entities = getSelectedFeedsEntity();
      }
      if (tonality && tonality.length) {
        tempParams.tonality = tonality;
      }
      if (category && category.length) {
        tempParams.category = category;
      }
      if (anchor_id) {
        tempParams.anchor_id = article.map(({ anchor_id }) => anchor_id);
      }
      if (channel_id) {
        tempParams.channel_id = channel_id;
      }
      if (language_id) {
        tempParams.language_id = language_id;
      }
      if (is_client_favourite) {
        tempParams.is_client_favourite = is_client_favourite;
      }
      if (headline) {
        tempParams.headline = headline;
      }
      setIsLoading(true);
      // const getDownloadFeeds = () => {
      //   if (isLoggedIn()) {
      //     return envConfig.DOWNLOAD_ARTICLE;
      //   } else return envConfig.DOWNLOAD_ARTICLE + "/1";
      // };
      fileDownloadMethod(
        `${envConfig.DOWNLOAD_ARTICLE_FOR_TV} `,
        tempParams,
        null,
        {
          type: "xls",
          clientName: selectedClient.client_name || clientName,
        }
      )
        .then(() => {
          setIsLoading(false);
          onSuccessCallback();
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  };

  const getButtonText = () => {
    if (!hideText) {
      if (customParams && customParams.title) {
        return "Download";
      }
      if ((article && article.length) || isTV) {
        return "Download Selected";
      }
      if (!isTV) {
        return "Download All";
      }
    }
    return "";
  };

  const downloadFormatsDropdown = () => {
    if (hideFormats) {
      return (
        <>
          {DOWNLOAD_FORMATS_FOR_DETAILS_PAGE.map((item, index) => (
            <Dropdown.Item key={index} onClick={(e) => dropdownClick(e, item)}>
              {item.label}
            </Dropdown.Item>
          ))}
        </>
      );
    } else {
      return (
        <>
          {DOWNLOAD_FORMATS.map((item, index) => (
            <Dropdown.Item key={index} onClick={(e) => dropdownClick(e, item)}>
              {item.label}
            </Dropdown.Item>
          ))}
        </>
      );
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : !isTV ? (
        <Dropdown alignRight>
          <Dropdown.Toggle variant="default">
            <DownloadBlueIcon />
            <span onClick={isTV && ((e) => dropdownClickForTv(e))}>
              {getButtonText()}
            </span>
          </Dropdown.Toggle>
          {<Dropdown.Menu>{downloadFormatsDropdown()}</Dropdown.Menu>}
        </Dropdown>
      ) : (
        <button
          className="dropdown-toggle btn btn-default"
          onClick={isTV && ((e) => dropdownClickForTv(e))}
          disabled={!article && !article.length}
        >
          <DownloadBlueIcon />
          <span>{getButtonText()}</span>
        </button>
      )}
    </>
  );
};
export default DownloadFeeds;
